export default "__VITE_ASSET__DlDB0K3j__"